module.exports = __webpack_public_path__ + "static/media/BM.bc861be4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/BM.svg
// module id = 207
// module chunks = 0